import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import store from "../store/store"
import 'element-ui/lib/theme-chalk/index.css';
import VueWechatTitle from 'vue-wechat-title'
import './css/element-red.scss'
import './css/global.scss'
import './utils/request'
// import VueHashCalendar from 'vue-hash-calendar'
// import 'vue-hash-calendar/lib/vue-hash-calendar.css'

const shortid = require('js-shortid');

import BeaconAction from './utils/tgp_h5_sdk.min.js'
// 上报成功回调，可根据实际业务调整，这里给到一种打印到控制台的方案  
const success = e => { console.log('onReportSuccess : ' + e); };
// 上报失败回调，可根据实际业务调整，这里给到一种打印到控制台的方案  
const fail = e => { console.log('onReportFail : ' + e); };
const beacon = new BeaconAction({
  appkey: 'L9ME1LVH3RD14XMR', // 数据资源appkey, 必填
  reportUrl: 'https://ubap-report.sany.com.cn/logserver/analytics/upload?tp=js', // 默认为 SAAS 服务的上报地址，私有化客户请在此传入您的上报地址
})

Vue.use(ElementUI);
Vue.use(VueWechatTitle);
// Vue.use(VueHashCalendar);
// Vue.use(Vuex);
Vue.config.productionTip = false

Vue.prototype.uuid = () => {
  return shortid.gen();
}
// const snap = require(`imports-loader?this=>window,fix=>module.exports=0!snapsvg/dist/snap.svg.js`);
// //console.log(snap)
var vue = new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')

export default vue